/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const project: ProjectConfiguration = feature.project;
    const NAME = feature.getSettingValue('NAME');
    const PROTOCOL = feature.getSettingValue('PROTOCOL');
    const LISTENPORTS = feature.getSettingValue('LISTENPORTS');
    const INTERFACES = feature.getSettingValue('INTERFACES');
    const SERVERIP = feature.getSettingValue('SERVERIP');
    const SERVERPORT = feature.getSettingValue('SERVERPORT');

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare ${NAME}_SOCK_NUM as byte`,
    });
    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `
dim ${NAME}_SOCK_NUM as byte`,
    });
    if (feature.getSettingValue('ROLE').toString() === 'server') {
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Sock ${NAME} setup
    '================================================================
    ${NAME}_SOCK_NUM=sock_get("${NAME}_SOCK_NUM")
    sock.num=${NAME}_SOCK_NUM
    sock.protocol=${PROTOCOL}
    sock.localportlist=${project.parseCodeExpression(LISTENPORTS, [], TibboDataType.STRING)}
    sock.inconmode=PL_SOCK_INCONMODE_ANY_IP_ANY_PORT
    sock.reconmode=PL_SOCK_RECONMODE_3
    sock.allowedinterfaces="NET,WLN,PPP"
    sock.txbuffrq(1)
    sock.rxbuffrq(1)
    sys.buffalloc()
    sys.debugprint("${PROTOCOL} server listening on port "+sock.localportlist)
    '-----------------------------------------------------------------`,
        });
    } else if (feature.getSettingValue('ROLE').toString() === 'client') {
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Sock ${NAME} connection setup
    '================================================================
    ${NAME}_SOCK_NUM=sock_get("${NAME}")
    sock.num=${NAME}_SOCK_NUM
    sock.protocol=${PROTOCOL}
    sock.inconmode=PL_SOCK_INCONMODE_NONE
    sock.allowedinterfaces="${INTERFACES}"
    sock.txbuffrq(1)
    sock.rxbuffrq(1)
    sys.buffalloc()
    sock.targetinterface=current_interface
    sock.targetip="${SERVERIP}"
    sock.targetport=${SERVERPORT}
    'sock.connect()
    'dim time_out as dword=sys.timercountms + 3000
    'while sock.statesimple<>PL_SSTS_EST and sys.timercountms<time_out   
    'wend
    'if sock.statesimple=PL_SSTS_EST then
    '    sys.debugprint("connected to server\\r\\n")
    'else
    '    sys.debugprint("could not connect to server\\r\\n")
    'end if
    '-----------------------------------------------------------------`,
        });
    }
    return blocks;
};
